import { useSelector } from '@betty/toolkit/state';
import {
  selectBestValueItems,
  selectCashRewardItems,
  selectedFreeSpinsItems,
  selectPurchasedItems,
} from '../state';
import { useCallback, useEffect, useState } from 'react';
import { staticShopFilters } from '../content/shop.content';
import { getSaleStatus } from '../utils/shop.utils';
import { SaleStatus } from '../state/sales/sales.types';
import { ShopFilterType } from '../state/types';
import { useShopRouteParams, useShopSales } from './index';

const useShopFilters = () => {
  const { shopSales } = useShopSales();
  const purchasedItems = useSelector(selectPurchasedItems);
  const bestValueItems = useSelector(selectBestValueItems);
  const cashRewardItems = useSelector(selectCashRewardItems);
  const freeSpinsItems = useSelector(selectedFreeSpinsItems);
  const { filterParam, setFilterParam } = useShopRouteParams();
  const [filters, setFilters] = useState<ShopFilterType[] | undefined>();

  const updateFilters = useCallback(() => {
    if (!shopSales) return;

    const saleFilters = shopSales
      .filter((sale) => getSaleStatus(sale) === SaleStatus.Ongoing)
      .map((sale) => sale.id);

    const staticFilters = staticShopFilters.filter((item) => {
      // Remove filters that don't have items
      if (item === 'BestValue' && !bestValueItems.length) return false;
      if (item === 'CashReward' && !cashRewardItems.length) return false;
      if (item === 'FreeSpins' && !freeSpinsItems.length) return false;
      if (item === 'Purchased' && !purchasedItems.length) return false;

      return true;
    });

    setFilters([...saleFilters, ...staticFilters]);
  }, [
    shopSales,
    bestValueItems,
    purchasedItems,
    cashRewardItems,
    freeSpinsItems,
  ]);

  const clearExpiredSaleFilter = useCallback(
    (filter: ShopFilterType) => {
      if (filterParam === filter) {
        setFilterParam(undefined);
      }
    },
    [filterParam, setFilterParam],
  );

  useEffect(updateFilters, [updateFilters]);

  return { filters, updateFilters, clearExpiredSaleFilter };
};

export default useShopFilters;
